(function($) {
  class W4DSocialPopupLogin {
    constructor(selector = '.w4d-social-popup') {
      this.selector = selector;
      this.init();
    }

    init() {
      $(document).ready(() => {
        this.bindPopupLinks();
      });
    }

    bindPopupLinks() {
      $(this.selector).each((_, el) => {
        $(el).on('click', (e) => this.openPopup(e, el));
      });
    }

    openPopup(e, el) {
      e.preventDefault();
      const url = el.href;
      const width = 600;
      const height = 600;
      const left = (screen.width / 2) - (width / 2);
      const top = (screen.height / 2) - (height / 2);

      const popup = window.open(
        url,
        'w4d_social_login',
        `width=${width},height=${height},top=${top},left=${left}`
      );    
    }

    checkLogin() {
      $.ajax({
        url: w4d_frontend_ajax.ajax_url,
        type: 'POST',
        data: {
          action: 'w4d_check_login'
        },
        success: (data) => {
          if (data.logged_in) {
            window.location.href = '/moj-racun';
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
         // console.error('Ajax error:', textStatus, errorThrown);
        }
      });
    }
  }

  $(document).ready(() => {
    new W4DSocialPopupLogin();
  });
})(jQuery);
